// Todos los montos del sistema se muestran con 2 decimales. `maxDecimales`
// permite ampliar (no reducir) en casos puntuales; sin pasarlo, son 2 fijos.
export function formatMonto(valor, maxDecimales) {
  const max = maxDecimales != null ? Math.max(2, maxDecimales) : 2;
  return Number(valor || 0).toLocaleString('es', {
    minimumFractionDigits: 2,
    maximumFractionDigits: max,
    useGrouping: 'always'
  });
}

export function formatFecha(valor) {
  if (!valor) return '';
  const [anio, mes, dia] = String(valor).slice(0, 10).split('-');
  return `${dia}/${mes}/${anio}`;
}

// Columnas DATETIME/TIMESTAMP: la BD guarda en UTC y el pool usa dateStrings,
// así que llegan como "2026-09-27 23:04:11" sin zona. Se marcan como UTC y se
// muestran en hora de Caracas. No usar con columnas DATE (esas van con formatFecha).
const ZONA = 'America/Caracas';

function partesCaracas(valor) {
  if (!valor) return null;
  const txt = String(valor);
  const iso = /[zZ]|[+-]\d\d:?\d\d$/.test(txt) ? txt : `${txt.replace(' ', 'T')}Z`;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  return Object.fromEntries(
    new Intl.DateTimeFormat('en-CA', {
      timeZone: ZONA, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(d).map((p) => [p.type, p.value])
  );
}

// DATETIME → "dd/mm/aaaa HH:MM" en hora de Caracas.
export function formatFechaHora(valor) {
  const p = partesCaracas(valor);
  return p ? `${p.day}/${p.month}/${p.year} ${p.hour}:${p.minute}` : '';
}

// DATETIME → "HH:MM" en hora de Caracas.
export function formatHora(valor) {
  const p = partesCaracas(valor);
  return p ? `${p.hour}:${p.minute}` : '';
}

// DATETIME mostrado solo como fecha → "dd/mm/aaaa" del día en Caracas
// (entre 20:00 y 24:00 de Caracas el día UTC ya es el siguiente).
export function formatFechaDeMarca(valor) {
  const p = partesCaracas(valor);
  return p ? `${p.day}/${p.month}/${p.year}` : '';
}

// Fecha de hoy (YYYY-MM-DD) en Caracas. No usar toISOString().slice(0, 10):
// da el día UTC, que desde las 20:00 de Caracas ya es mañana.
export function hoyCaracas() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: ZONA }).format(new Date());
}

export function obtenerIniciales(nombre) {
  if (!nombre) return '';
  const partes = nombre.trim().split(/\s+/);
  return partes.slice(0, 2).map((p) => p[0]?.toUpperCase()).join('');
}
